export default __webpack_public_path__ + "static/media/andes_a_la_selva_2.529f4701.JPG";